import { Hero } from "@/components/site/Hero";
import { ServiceCard } from "@/components/site/ServiceCard";
import { ValueProps } from "@/components/site/ValueProps";
import { SERVICES } from "@/data/services";

export default function Home({ theme }) {
  return (
    <>
      <Hero theme={theme} />

      <section id="services" className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center">
            <h2 className="font-heading text-4xl tracking-tight text-[color:var(--rs-text)] lg:text-5xl">
              Vores services
            </h2>
            <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[color:var(--rs-gold)]">
              Alt samlet ét sted – så du kan fokusere på det vigtige
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4 lg:gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.id} service={s} />
            ))}
          </div>
        </div>
      </section>

      <ValueProps />
    </>
  );
}
